<template>
  <a-cascader
    v-decorator="['area']"
    :options="options"
    placeholder="Please select"
    :field-names="{ label: 'name', value: 'code', children: 'children' }"
    :defaultValue="defaultValueArea"
    :changeOnSelect="true"
    @change="onChange"
  />
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      options: [],
      areaArr: []
    };
  },
  watch: {
    defaultValueArea: {
      handler(val) {
        let arr = JSON.stringify(val);
        return JSON.parse(arr);
      },
      deep: true
    }
  },
  props: {
    area: {
      type: String,
      default: "area"
    },
    onChange: {
      type: Function
    },
    defaultValueArea: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  mounted() {
    this.getArea();
  },
  methods: {
    async getArea() {
      try {
        const data = await Api.Area.getArea();
        this.options = data.areas;
      } catch (e) {
        console.log(e, "获取地区错误");
      }
    }
  }
};
</script>
<style scoped></style>
